import { PageTemplate } from '@/shared/ui/templates'
import styles from './index.module.sass'
import { LogisticsLeftbar } from '../../components/logistics-leftbar'
import { LogisticsRightbar } from '../../components/logistics-rightbar'

export const LogisiticsPage = () => {
    return (
        <PageTemplate header="Логистика" customBack={-1}>
            <div className={styles.root}>
                <div className={styles.container}>
                    <LogisticsLeftbar/>
                </div>
                <div className={styles.container}>
                    <LogisticsRightbar/>
                </div>
            </div>
        </PageTemplate>
    )
}